"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSTLoggingRouteHandler = void 0;
const logger_1 = require("./logger");
const validLogLevels = {
    error: 'error',
    debug: 'debug',
    fatal: 'fatal',
    info: 'info',
    trace: 'trace',
    silent: 'silent',
    warn: 'warn',
};
function isValidLoggingLabel(label) {
    return typeof label === 'string' && label in validLogLevels;
}
const POSTLoggingRouteHandler = (request) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const body = yield request.json();
    const { level, ts } = body;
    const label = level.label;
    if (!isValidLoggingLabel(label)) {
        return Response.json({
            error: `Invalid label ${label}`,
        }, { status: 400 });
    }
    const messages = body.messages;
    logger_1.logger
        .child({
        x_timestamp: ts,
        x_isFrontend: true,
        x_userAgent: request.headers.get('user-agent'),
        x_request_id: (_a = request.headers.get('x-request-id')) !== null && _a !== void 0 ? _a : 'not-set',
    })[label](...messages);
    return Response.json({ ok: `ok` });
});
exports.POSTLoggingRouteHandler = POSTLoggingRouteHandler;
